import { createDraftSafeSelector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { TourStep } from '../components/tour/tour.typings'

const state = (state: RootState) => state


export const selectTourSteps = createDraftSafeSelector(state, (store: RootState) => store.tourStore.steps as TourStep[])
export const selectCurrentStep = createDraftSafeSelector(state, (store: RootState) => store.tourStore.currentStep as number)